import React from "react";
import { Card, Placeholder } from "react-bootstrap";

import DstButton from "../../../../components/DstButton/DstButton";
import translate from "../../../../services/Translate";
import { intToHex } from "../../LandingPageJobBlocks.function";
import { CardJobBlockProps } from "./CardJobBlock.d";

const _categoryColors: Record<string, string> = {
  Data: "var(--color-turquoise)",
  Dev: "var(--color-volt)",
  Cyber: "var(--color-violet-plum)",
  Digital: "var(--color-magenta-pink)",
};

const CardJobBlock = ({ jobBlock, onEdit, onDelete, mock, language }: CardJobBlockProps) => {
  if (mock) {
    return (
      <Placeholder as="div" animation="glow" role="mockup">
        <Card
          className="h-100 p-2 shadow-sm rounded-plus s-regular"
          style={{
            border: "none",
            borderTop: "3px solid var(--color-medium-gray)",
          }}
        >
          <Card.Body className="d-flex flex-column justify-content-between">
            <Placeholder xs={4} className="mb-2" />

            <div className="mt-3">
              <Placeholder as="h5" xs={7} className="mb-2" />

              <div className="mb-3">
                <Placeholder xs={12} className="d-block mb-2" />
                <Placeholder xs={11} className="d-block mb-2" />
                <Placeholder xs={9} className="d-block" />
              </div>

              <div className="d-flex flex-wrap gap-2 mb-3">
                {[...Array(3)].map((_, index) => (
                  <Placeholder
                    key={`jobblock-mock-tag-${index}`}
                    as="span"
                    xs={3}
                    className="rounded-pill"
                    style={{ height: 24 }}
                  />
                ))}
              </div>

              <Placeholder xs={12} className="d-block mb-2" />
            </div>

            <div className="d-flex gap-2 mt-4">
              <DstButton mock btnWidth="50px" />
              <DstButton mock btnWidth="60px" />
            </div>
          </Card.Body>
        </Card>
      </Placeholder>
    );
  }
  return (
    <Card
      className="h-100 p-2 shadow-sm rounded-plus s-regular"
      style={{
        border: "none",
        borderTop: `3px solid ${_categoryColors[jobBlock.category] || "var(--color-medium-gray)"}`,
      }}
    >
      {jobBlock.deprecated && (
        <span className="position-absolute top-0 end-0 m-2 badge bg-warning text-dark d-flex align-items-center gap-1">
          <span className="dst-icon dst-icon-alert-circle" />
          {translate(language, "GLOBAL.DEPRECATED")}
        </span>
      )}
      <Card.Body className="d-flex flex-column justify-content-between">
        <div>
          <p className="m-bold">{jobBlock.category}</p>
          {jobBlock.subcategory && <p className="m-bold">{jobBlock.subcategory}</p>}
          <Card.Title className="h5 fw-semibold">{jobBlock.title}</Card.Title>
          <p className="text-muted">
            {jobBlock.question} <br />
            {jobBlock.resume}
          </p>
          {jobBlock.tags && jobBlock.tags.length > 0 && (
            <div className="d-flex flex-wrap gap-2 mb-3">
              {jobBlock.tags.map((tag, index) => {
                return (
                  <span
                    key={`tag-${index}`}
                    className="badge rounded-pill px-2 py-1 text-wrap"
                    style={{
                      backgroundColor: intToHex(tag.background_color),
                      color: intToHex(tag.text_color),
                    }}
                  >
                    {tag.text}
                  </span>
                );
              })}
            </div>
          )}
        </div>
        <p className="s-regular">
          <a href={jobBlock.link} target="_blank" rel="noreferrer">
            {jobBlock.link}
          </a>
        </p>
        <div className="d-flex gap-2">
          <DstButton
            value={translate(language, "PAGES.LANDING_PAGE_JOB_BLOCKS.CARD.BUTTON.EDIT")}
            clickFunction={onEdit}
          />
          <DstButton value={translate(language, "GLOBAL.DELETE")} variant="danger" clickFunction={onDelete} />
        </div>
      </Card.Body>
    </Card>
  );
};

export default CardJobBlock;
